const utils = require('frontend-controller/lib/utils')

module.exports = {
	config: {
		translationPrefix: 'bulk',
		tableComponentClass: 'templates_bulk_contentTable',
		controllerComponentClass: 'templates_bulk_contentController'
	},

	model: {
		nrOfElementsAttributes: {},
		nrOfSelectedElements: 0
	},

	methods: {
		prepare: function(storage, isServer){
			if(!isServer){
				var self = this;
				self.closest(self.config.controllerComponentClass, function(controller){
					controller.find(self.config.tableComponentClass, function(table){
						self.model.nrOfElementsAttributes = ((table.resourceData.nrOfElements || {}).data || {}).attributes || {};
						self.model.nrOfElementsAttributes.nrOfVisibleElements = Object.keys(table.model.entityList || {}).length || 0;
					});
				});
			}
		}
	},

	hooks: {
		onTableSelectionChanged: function($element, options){
			this.model.nrOfSelectedElements = utils.collectionSize((options || {}).selectedRowIDs || {})
			this.refresh();
		}
	},

	handlers: [{
		name: 'refreshResources',
		handle: function(callerComponent) {
			if(callerComponent.componentClass === this.config.tableComponentClass && this.config.isReady && this.$.length > 0){
				this.refresh();
			}
		}
	}]
};
